import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { catchError, of, shareReplay } from 'rxjs';
import { VermittlerService } from '../interfaces/generated';

/**
 * Why the Vermittler could not be loaded: `not-activated` when the backend rejects
 * the Vermittler (403), `unavailable` for any other failure (5xx, network).
 */
export type VermittlerError = 'not-activated' | 'unavailable';

@Injectable({ providedIn: 'root' })
export class VermittlerCacheService {
  private readonly vermittlerService = inject(VermittlerService);

  vermittlerError = signal<VermittlerError | null>(null);

  vermittler$ = this.vermittlerService.getVermittler({}).pipe(
    catchError(err => {
      this.vermittlerError.set(
        err instanceof HttpErrorResponse && err.status === HttpStatusCode.Forbidden
          ? 'not-activated'
          : 'unavailable'
      );
      return of(null);
    }),
    shareReplay(1)
  );
}
